<template>
  <div :class="$style.multipleAuditDatepickerColumn" v-if="dirtyDatepickerItem">
    <div class="field" :class="$style.period">
      <label :class="$style.periodLabel">
        {{ dirtyDatepickerItem.auditName }}
      </label>
      <div :class="$style.datePickerFieldContainer">
        <b-datepicker
          range
          v-model="dirtyPeriodRange"
          @input="updateDatePeriod"
          placeholder="Click to select..."
          icon="calendar-today"
          icon-pack="mdi"
          :class="[$style.customCalendarIcon, 'calender-icon']"
          nearby-selectable-month-days
          :date-formatter="(date) => formatDataCollectionDateRange(date)"
        >
        </b-datepicker>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getStartDateTime, getEndDateTime } from '../../../utils/date.util';
import { cloneData } from '@/utils/general.util';
import { DataCollectionPeriodDTO } from '@/store/modules/projects/types/projects.types';
const dirtyMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

@Component({ components: {} })
export default class ProjectCreationMultipleDatePicker extends Vue {
  @Prop()
  public datepickerItem!: DataCollectionPeriodDTO;
  @Prop()
  public periodIndex!: number;

  public dirtyDatepickerItem: DataCollectionPeriodDTO = cloneData(
    this.datepickerItem,
  );
  public dirtyPeriodRange: Date[] = [];
  public showEditLabelInput: boolean = false;
  public newLabel: string = '';
  public emptyLabelError: boolean = false;

  public mounted() {
    const startDate: Date = getStartDateTime(
      this.dirtyDatepickerItem.startDate,
    );
    const endDate: Date = getStartDateTime(this.dirtyDatepickerItem.endDate);
    this.dirtyPeriodRange.push(startDate);
    this.dirtyPeriodRange.push(endDate);
  }

  public getDate(newValue: Date): string {
    return (
      newValue.getDate() +
      ' ' +
      dirtyMonths[newValue.getMonth()] +
      ' ' +
      newValue.getFullYear()
    );
  }

  public formatDataCollectionDateRange(date: Date[]): string {
    if (date && date.length) {
      return this.getDate(date[0]) + ' - ' + this.getDate(date[1]);
    }
    return '';
  }

  public updateDatePeriod(newValue: Date[]) {
    const dataCollectionPeriodDate: {
      auditName: string;
      auditNumber: number;
      startDate: Date;
      endDate: Date;
    } = {
      auditName: this.dirtyDatepickerItem.auditName,
      auditNumber: this.periodIndex,
      startDate: getStartDateTime(newValue[0]),
      endDate: getEndDateTime(newValue[1]),
    };
    this.$emit('updateDatePicker', dataCollectionPeriodDate);
  }
}
</script>
<style lang="scss" module>
.multipleAuditDatepickerColumn {
  margin-top: 14px;
  margin-bottom: 6px;
  -webkit-box-flex: 0;
  flex: none;
  display: block;
  padding: 0.75rem;
  width: 50%;

  .period {
    .periodLabel {
      text-align: left;
      font-weight: 600;
      font-size: 16px;
      color: #444f51;
      padding-bottom: 1rem;
    }

    .columns {
      color: red;
    }
    width: 350px;
    margin-bottom: 0 !important;
  }
}
.customCalendarIcon {
  i::before {
    padding-top: 13px;
    padding-bottom: 12px;
    width: 15px;
    margin-right: 10px;
  }
}

.datePickerFieldContainer {
  padding-top: 0.75rem !important;
}
</style>
